import React from "react";
import { Grid, Typography } from "@material-ui/core";
import EditText from "../../components/EditText";
import { useTranslation } from "react-i18next";

const AddressView = (props) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography color="textPrimary" variant="h5">
          {t("register.address_title")}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <EditText {...props} label={t("register.country")} name="country" />
      </Grid>
      <Grid item xs={12}>
        <EditText {...props} label={t("register.district")} name="district" />
      </Grid>
      <Grid item xs={12}>
        <EditText {...props} label={t("register.city")} name="city" />
      </Grid>
      <Grid item xs={12}>
        <EditText {...props} label={t("register.cap")} name="cap" />
      </Grid>
      <Grid item xs={12}>
        <EditText {...props} label={t("register.street")} name="street" />
      </Grid>
    </Grid>
  );
};

export default AddressView;
